module.exports = __webpack_public_path__ + "img/jobmule-logo-small.1a822544.png";